import { ReactSDKClient } from '@optimizely/react-sdk'
import { ActivateListenerPayload, enums } from '@optimizely/optimizely-sdk'

import createCheggInstance, {
  FullStackTrackable,
  TrackingAdapter,
} from '@chegg/optimizely-sdk'
import { Config } from '@chegg-wt/core/config'
import { isWindowDefined } from '@chegg-wt/core/utils/isWindowDefined'
import { isProduction, enableOptimizelyLogger } from '@chegg-wt/core/utils/env'
import { getCookie, Cookies } from '@chegg-wt/core/utils/cookies'
import { addQueryString } from '@chegg-wt/core/utils/url'

const SEM_PARAM_KEY = 'c_id'
const SEM_PARAM_VALUE = 'sem'

// EB landing pages set cookie to let us know users came from SEM.
// Once we integrate Optly Fullstack and Optly Web,
// or we add Optly Fullstack to landing pages, we won't need this.
const addSemQueryParamFromCookie = (queryString: string): string => {
  return getCookie(Cookies.OptimizelyFromMarketing) === 'true'
    ? addQueryString(queryString, { [SEM_PARAM_KEY]: SEM_PARAM_VALUE })
    : queryString
}

// Configure dataLayer allocation event
// move to middleware
export function onActivate(activateObject: ActivateListenerPayload) {
  const eventCategory = 'Optimizely'
  const eventAction = `Experiment - ${activateObject.experiment.key}`
  const eventLabel = `Variation - ${activateObject.variation.key}`

  // @ts-ignore
  window.dataLayer.push({
    eventCategory,
    eventAction,
    eventLabel,
    event: 'event',
  })
}

let optClient: ReactSDKClient

let trackingAdapterInstance: TrackingAdapter

export const track = (event: FullStackTrackable) => {
  if (trackingAdapterInstance) trackingAdapterInstance(event)
}

// eslint-disable-next-line import/no-mutable-exports
export let resolveRioPromise
const rioInitPromise: Promise<void> = new Promise((resolve) => {
  resolveRioPromise = resolve
})

const initialize = (cookieDomain: string) => {
  if (!isWindowDefined) return null

  if (optClient) return optClient

  const queryStringOnPageLoad = window?.location?.search

  const { optimizelySdkKey, optimizelyProjectId } = Config

  // check that we are either not in a production build, or that they have agreed to be tracked
  // @ts-ignore
  // eslint-disable-next-line no-underscore-dangle
  const gdpr = !isProduction() || window.__sbmNoGdpr === true

  if (!(optimizelySdkKey && optimizelyProjectId && gdpr)) {
    return null
  }

  const { optimizely, trackingAdapter } = createCheggInstance({
    queryStringOnPageLoad: addSemQueryParamFromCookie(queryStringOnPageLoad),
    cookieDomain,
    sdkKey: optimizelySdkKey,
    projectGamKeyPrefix: 'wt_optimizely_',
    rioConfig: { project_id: optimizelyProjectId, rioInitPromise },
    logLevel: enableOptimizelyLogger() ? enums.LOG_LEVEL.INFO : enums.LOG_LEVEL.ERROR,
  })

  trackingAdapterInstance = trackingAdapter
  optimizely.notificationCenter.addNotificationListener(
    enums.NOTIFICATION_TYPES.ACTIVATE,
    onActivate
  )

  optClient = optimizely

  return optClient
}

export default initialize
